import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// ADMIN AUTH HEADER
// ================================

function getAdminAuthConfig() {
  const token = sessionStorage.getItem("accessToken");

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}


// ================================
// ADMIN USER APIs
// ================================

// 1) GET USERS LIST
export async function getUsersApi(payload) {
  try {
    const fd = new FormData();

    fd.append("page", payload.page || 1);
    fd.append("limit", payload.limit || 8);
    fd.append("search", payload.search || "");
    fd.append("verification", payload.verification || "");
    fd.append("signup_mode", payload.signup_mode || "");
    fd.append("city", payload.city || "");

    const res = await axios.post(
      `${apiBaseUrl}admin/users/list`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get Users Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Users fetch failed",
    };
  }
}


// ================================
// 2) GET USER STATS
// ================================

export async function getUserStatsApi() {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/users/stats`,
      {},
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get User Stats Error:", err);

    return {
      status: false,
      type: "danger",
      success: "User stats fetch failed",
    };
  }
}


// ================================
// 3) VIEW USER
// ================================

export async function getUserApi(userId) {
  try {
    const fd = new FormData();

    fd.append("user_id", userId || "");

    const res = await axios.post(
      `${apiBaseUrl}admin/users/view`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get User Error:", err);

    return {
      status: false,
      type: "danger",
      success: "User fetch failed",
    };
  }
}


// ================================
// 4) CREATE USER
// ================================

export async function createUserApi(payload) {
  try {
    const fd = new FormData();

    fd.append("name", payload.name || "");
    fd.append("email", payload.email || "");
    fd.append("mobile", payload.mobile || "");
    fd.append("signup_mode", payload.signup_mode || "");

    fd.append("country", payload.country || "");
    fd.append("state", payload.state || "");
    fd.append("city", payload.city || "");
    fd.append("pincode", payload.pincode || "");
    fd.append("address", payload.address || "");

    fd.append("youtube_channel", payload.youtube_channel || "");
    fd.append("insta_link", payload.insta_link || "");
    fd.append("portfolio_link", payload.portfolio_link || "");

    fd.append(
      "isVerified",
      payload.isVerified ? "1" : "0"
    );

    if (payload.image) {
      fd.append("image", payload.image);
    }

    const res = await axios.post(
      `${apiBaseUrl}admin/users/create`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Create User Error:", err);

    return {
      status: false,
      type: "danger",
      success: "User creation failed",
    };
  }
}


// ================================
// 5) UPDATE USER
// ================================

export async function updateUserApi(payload) {
  try {
    const fd = new FormData();

    fd.append("user_id", payload.user_id || "");

    fd.append("name", payload.name || "");
    fd.append("email", payload.email || "");
    fd.append("mobile", payload.mobile || "");
    fd.append("signup_mode", payload.signup_mode || "");

    fd.append("country", payload.country || "");
    fd.append("state", payload.state || "");
    fd.append("city", payload.city || "");
    fd.append("pincode", payload.pincode || "");
    fd.append("address", payload.address || "");

    fd.append("youtube_channel", payload.youtube_channel || "");
    fd.append("insta_link", payload.insta_link || "");
    fd.append("portfolio_link", payload.portfolio_link || "");

    fd.append(
      "isVerified",
      payload.isVerified ? "1" : "0"
    );

    if (payload.image) {
      fd.append("image", payload.image);
    }

    const res = await axios.post(
      `${apiBaseUrl}admin/users/update`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Update User Error:", err);

    return {
      status: false,
      type: "danger",
      success: "User update failed",
    };
  }
}


// ================================
// 6) DELETE USER
// ================================

export async function deleteUserApi(userId) {
  try {
    const fd = new FormData();

    fd.append("user_id", userId || "");

    const res = await axios.post(
      `${apiBaseUrl}admin/users/delete`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Delete User Error:", err);

    return {
      status: false,
      type: "danger",
      success: "User deletion failed",
    };
  }
}